export default __webpack_public_path__ + "static/media/banner-demo.3e8166b7.jpg";